import React from 'react';
import ConfirmationPopup from './ConfirmationPopup';
import folderDeleteIcon from '../../../icons/icon-folder-delete.png';

const DeleteFolderConfirmation = ({
  onClose,
  onConfirm,
  folderName,
  error = null,
  isLoading = false,
}) => {
  return (
    <ConfirmationPopup
      onClose={onClose}
      onConfirm={onConfirm}
      icon={folderDeleteIcon}
      iconAlt="Delete folder"
      title="Delete this folder?"
      description="Only empty folders can be deleted. Move or delete all items inside first."
      error={error}
      isLoading={isLoading}
    />
  );
};

export default DeleteFolderConfirmation;
